import axios from 'axios';
import { config } from 'Constants';

/**
 * Returns authorization headers with user token
 * @returns {Object} Headers object with Content-Type and Authorization
 */
const getAuthHeaders = (additionalHeaders = {}) => {
    const user = JSON.parse(localStorage.getItem('user'));
    return {
        'Content-Type': 'application/json',
        Authorization: user.token,
        ...additionalHeaders,
    };
};

/**
 * Creates the base URL for the API
 * @param {String} endpoint - API endpoint path
 * @returns {String} Complete API URL
 */
const createApiUrl = (endpoint) => `${config.url.API_URL}/api/kahramanlar/${endpoint}`;

/**
 * Retrieves all user baskets with optional filtering
 * @param {Object} query - Query parameters (page, limit, isActive, etc.)
 * @returns {Promise} Axios promise with baskets list response
 */
export const getBaskets = (query) => {
    const url = createApiUrl('baskets');
    return axios.get(url, {
        headers: getAuthHeaders(),
        params: query,
    });
};

/**
 * Retrieves specific basket by ID
 * @param {String} id - Basket ID
 * @returns {Promise} Axios promise with basket response
 */
export const getBasket = (id) => {
    const url = createApiUrl(`baskets/${id}`);
    return axios.get(url, {
        headers: getAuthHeaders(),
    });
};

/**
 * Creates a new basket
 * @param {Object} basketData - Basket data including name, description, and items
 * @returns {Promise} Axios promise with created basket response
 */
export const saveBasket = (basketData) => {
    const url = createApiUrl('baskets');
    return axios.post(url, basketData, {
        headers: getAuthHeaders(),
    });
};

/**
 * Updates existing basket
 * @param {String} id - Basket ID
 * @param {Object} data - Updated basket data
 * @returns {Promise} Axios promise with updated basket response
 */
export const updateBasket = (id, data) => {
    const url = createApiUrl(`baskets/${id}`);
    return axios.put(url, data, {
        headers: getAuthHeaders(),
    });
};

/**
 * Deletes basket by ID
 * @param {String} id - Basket ID
 * @returns {Promise} Axios promise with delete response
 */
export const deleteBasket = (id) => {
    const url = createApiUrl(`baskets/${id}`);
    return axios.delete(url, {
        headers: getAuthHeaders(),
    });
};

/**
 * Creates a copy of existing basket
 * @param {String} id - Original basket ID
 * @param {Object} copyData - Additional data for the copy (optional)
 * @returns {Promise} Axios promise with copied basket response
 */
export const copyBasket = (id, copyData = {}) => {
    const url = createApiUrl(`baskets/${id}/copy`);
    return axios.post(url, copyData, {
        headers: getAuthHeaders(),
    });
};

/**
 * Legacy method - kept for backward compatibility
 * @deprecated Use saveBasket instead
 */
export const postBasket = (data) => {
    return saveBasket(data);
};
